import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const ALLOWED_DOMAINS = ['cudaops.com', 'barracuda.com', 'barracudanetworks.com']

const isValidRetryUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') return false
    return ALLOWED_DOMAINS.some(domain => parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`))
  } catch {
    return false
  }
}

export interface ErrorState {
  errorCode: string
  contextId: string
  retryUrl: string
  onRetry: () => void
}

export type UseErrorLogic = ErrorState

export const useErrorLogic = (): UseErrorLogic => {
  const [params] = useSearchParams()

  // Keep URL params intact for refresh/copy-to-support scenarios
  const errorCode = params.get('error_code') ?? ''
  const contextId = params.get('context_id') ?? ''
  const retryUrl = params.get('retry_url') ?? ''

  const onRetry = useCallback(() => {
    if (isValidRetryUrl(retryUrl)) {
      window.location.href = retryUrl
    }
  }, [retryUrl])

  return useMemo(
    () => ({
      errorCode,
      contextId,
      retryUrl: isValidRetryUrl(retryUrl) ? retryUrl : '',
      onRetry
    }),
    [errorCode, contextId, retryUrl, onRetry]
  )
}
